import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { StyledContainerInput } from '../../../components/form-components/light-select-search-bar-async/styled-input.style'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import {
	SelectInput,
	TextInput,
} from '../../../components/form-components/inputs.component'
import styled from 'styled-components'
import { Formik } from 'formik'
import Yup from './../../../helpers/custom-yup'

class ReasonForTravelData extends React.Component {
	constructor(props) {
		super(props)
		this.formRef = React.createRef()
		this.renderFormik = this.renderFormik.bind(this)
		this.handleReasonForTravel = this.handleReasonForTravel.bind(this)
		this.state = {
			isOtherTravelReason: false,
		}
	}

	handleReasonForTravel(options) {
		if (options === 'Outro') {
			this.setState({ isOtherTravelReason: true })
		} else {
			this.setState({ isOtherTravelReason: false })
		}
	}

	componentDidMount() {
		this.props.getFormRef(this.formRef.current)
	}

	renderFormik = (props) => {
		return (
			<StyledContainerInput>
				<StyledInputContainer>
					<SelectInput
						{...props}
						onValueChange={this.handleReasonForTravel}
						multi={false}
						label="Qual o objetivo principal de sua viagem?"
						id="travelReason"
						className={'col-3'}
						options={[
							{ value: 'Lazer/Turismo', label: 'Lazer/Turismo' },
							{ value: 'Trabalho', label: 'Trabalho' },
							{ value: 'Estudo', label: 'Estudo' },
							{ value: 'Saúde', label: 'Saúde' },
							{ value: 'Outro', label: 'Outro' },
						]}
					/>
				</StyledInputContainer>
				{this.state.isOtherTravelReason && (
					<TextInput
						{...props}
						id="otherTravelReason"
						type="text"
						placeholder="Qual?"
						maxLength={50}
					/>
				)}
			</StyledContainerInput>
		)
	}

	render() {
		return (
			<Formik
				ref={this.formRef}
				render={this.renderFormik}
				validationSchema={schema}
				onSubmit={this.props.onSubmit}
				initialValues={{
					travelReason: '',
					otherTravelReason: '',
				}}
			/>
		)
	}
}

const schema = Yup.object().shape({
	travelReason: Yup.string(),
	otherTravelReason: Yup.string().max(50, 'Limite de 100 caracteres'),
})

const mapStateToProps = (store) => ({
	travelReason: store.ticketSale.travelReason,
	otherTravelReason: store.ticketSale.otherTravelReason,
})

export const StyledInputContainer = styled.div`
	margin-bottom: 3rem;
	align-self: center;
	width: 100%;
`

export default connect(mapStateToProps)(ReasonForTravelData)
